export enum Role {
  admin = 1,
  adminChapter = 2,
  evaluator = 3,
  approver = 4,
  reporter = 5,
  goalGroupManager = 6,
  visualizer = 13,
  evalualor_team_pp = 14,
  pragmatico = 15,
}
export const FRONTEND_CHAPTER_ID: number = 17;
export const BACKEND_CHAPTER_ID: number = 4;
export const CHAPTER_NO_ASSESSMENT: string = 'Sin review de crecimiento';
export const STATUS_PENDING: string = 'Pendiente';
export const STATUS_REJECT: string = 'Rechazado';
export const STATUS_APPROVED: string = 'Aprobado';
export const ORIGIN_CHAPTER_CRECI: string = 'creci';
export const ORIGIN_CHAPTER_CLASSROOM: string = 'classroom';
